<template>
  <v-container fluid>
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="glass-card">
          <v-card-title class="d-flex align-center">
            <v-icon left color="primary" large>mdi-qrcode</v-icon>
            <span class="text-h5">QR Kod Meni</span>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-container>
              <!-- Main Toggle -->
              <v-row>
                <v-col cols="12">
                  <v-switch
                    v-model="settings.qr_menu_enabled"
                    label="Omogući QR kod meni"
                    color="primary"
                    :loading="loading"
                    @change="onEnableChange"
                    class="mt-0"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <span class="text-subtitle-1 font-weight-medium">Omogući QR kod meni</span>
                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="grey"
                              small
                              class="ml-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>Omogućite javni pristup meniju putem QR koda. Meni će biti dostupan bez prijave na jedinstvenom linku.</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
              </v-row>

              <div v-if="settings.qr_menu_enabled">
                <!-- Template Selection -->
                <v-card class="glass-section-card mb-6" elevation="0">
                  <v-card-subtitle class="section-header d-flex align-center pb-2">
                    <v-icon left color="primary">mdi-palette-swatch</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Odabir predloška</span>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="settings.selected_template"
                          :items="templateOptions"
                          label="Odaberite predložak"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                          @change="onTemplateChange"
                        >
                          <template v-slot:selection="{ item }">
                            <div class="d-flex align-center">
                              <v-icon small :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-avatar>
                              <v-icon :color="item.color">{{ item.icon }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{ item.text }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Dynamic Template Component -->
                <component
                  :is="currentTemplateComponent"
                  :settings="settings"
                  @update:settings="updateSettings"
                ></component>

                <!-- Hero Section Settings (OLD - will be removed) -->
                <v-card v-if="false" class="glass-section-card mb-6" elevation="0">
                  <v-card-subtitle class="section-header d-flex align-center pb-2">
                    <v-icon left color="primary">mdi-image-area</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Hero sekcija</span>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="settings.hero_image_url"
                          label="URL slike"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                          placeholder="https://..."
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="settings.custom_restaurant_name"
                          label="Naziv"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                          placeholder="Naziv restorana"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="settings.hero_description"
                          label="Opis"
                          outlined
                          dense
                          rows="2"
                          hide-details
                          class="qr-input-field"
                          placeholder="Kratak opis lokacije"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="settings.hero_text_color"
                          label="Boja teksta"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                          placeholder="#2c3e50"
                        >
                          <template v-slot:append>
                            <input
                              type="color"
                              v-model="settings.hero_text_color"
                              style="width: 30px; height: 30px; border: none; cursor: pointer; border-radius: 4px;"
                            />
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-checkbox
                          v-model="settings.hero_transparent_background"
                          label="Transparentna pozadina"
                          dense
                          hide-details
                          color="primary"
                          class="mb-3"
                        ></v-checkbox>
                        <v-text-field
                          v-model="settings.hero_background_color"
                          label="Pozadinska boja"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                          placeholder="#ffffff"
                          :disabled="settings.hero_transparent_background"
                        >
                          <template v-slot:append>
                            <input
                              type="color"
                              v-model="settings.hero_background_color"
                              style="width: 30px; height: 30px; border: none; cursor: pointer; border-radius: 4px;"
                              :disabled="settings.hero_transparent_background"
                            />
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="settings.hero_font_family"
                          :items="fontOptions"
                          label="Font"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="settings.hero_font_size"
                          :items="fontSizeOptions"
                          label="Veličina fonta"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="settings.hero_text_align"
                          :items="textAlignOptions"
                          label="Poravnanje teksta"
                          outlined
                          dense
                          hide-details
                          class="qr-input-field"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-checkbox
                          v-model="settings.show_logo"
                          label="Prikaži logo firme"
                          dense
                          hide-details
                          color="primary"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Functionality Settings Section -->
                <v-card class="glass-section-card mb-6" elevation="0">
                  <v-card-subtitle class="section-header d-flex align-center pb-2">
                    <v-icon left color="primary">mdi-feature-search-outline</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Dodatne funkcionalnosti</span>
                    <v-chip x-small color="grey" outlined class="ml-2">Uskoro</v-chip>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-checkbox
                          v-model="settings.enable_ordering"
                          label="Omogući narudžbe"
                          dense
                          hide-details
                          color="primary"
                          disabled
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-checkbox
                          v-model="settings.enable_call_waiter"
                          label="Omogući poziv konobara"
                          dense
                          hide-details
                          color="primary"
                          disabled
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- QR Code Display Section -->
                <v-card v-if="menuUrl" class="glass-section-card mb-6" elevation="0">
                  <v-card-subtitle class="section-header d-flex align-center pb-2">
                    <v-icon left color="primary">mdi-qrcode-scan</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">QR Kod za pristup meniju</span>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="d-flex flex-column align-center">
                        <div class="qr-code-wrapper pa-4">
                          <canvas ref="qrcode"></canvas>
                        </div>

                        <v-chip
                          color="primary"
                          outlined
                          class="mt-4 mb-3"
                          @click="copyUrl"
                        >
                          <v-icon left small>mdi-link</v-icon>
                          {{ menuUrl }}
                          <v-icon right small>mdi-content-copy</v-icon>
                        </v-chip>

                        <div class="d-flex flex-wrap justify-center">
                          <v-btn
                            class="qr-action-btn primary-btn"
                            @click="downloadQR"
                            elevation="0"
                          >
                            <v-icon left small>mdi-download</v-icon>
                            Preuzmi PNG
                          </v-btn>
                          <v-btn
                            class="qr-action-btn secondary-btn"
                            @click="copyUrl"
                            elevation="0"
                          >
                            <v-icon left small>mdi-content-copy</v-icon>
                            Kopiraj Link
                          </v-btn>
                          <v-btn
                            class="qr-action-btn accent-btn"
                            @click="printQR"
                            elevation="0"
                          >
                            <v-icon left small>mdi-printer</v-icon>
                            Print
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              class="save-btn"
              @click="save"
              :loading="saving"
              :disabled="!settings.qr_menu_enabled && !hasChanges"
              elevation="0"
            >
              <v-icon left small>mdi-content-save</v-icon>
              Spremi postavke
            </v-btn>
          </v-card-actions>
        </v-card>

        <!-- Snackbar for notifications -->
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="3000"
          bottom
        >
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Zatvori
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QRCode from 'qrcode'
import { df } from '@/plugins/firebase'
import state from '@/state'
import TemplateAikasa from '../qr-templates/TemplateAikasa.vue'
import TemplateModern from '../qr-templates/TemplateModern.vue'

export default {
  name: 'QRMenu',
  components: {
    TemplateAikasa,
    TemplateModern
  },
  data: () => ({
    location: null,
    settings: {
      qr_menu_enabled: false,
      selected_template: 'aikasa',
      hero_image_url: '',
      custom_restaurant_name: '',
      hero_description: '',
      hero_text_color: '',
      hero_background_color: '',
      hero_transparent_background: true,
      hero_font_family: '',
      hero_font_size: 'medium',
      hero_text_align: 'center',
      show_logo: true,
      items_primary_color: '#00b3be',
      items_font_family: '',
      show_images: true,
      show_descriptions: true,
      show_allergens: true,
      show_prices: true,
      clickable_items: false,
      enable_ordering: false,
      enable_call_waiter: false,
      hide_inactive_items: true,
      hide_empty_categories: true
    },
    templateOptions: [
      {
        text: 'Aikasa',
        value: 'aikasa',
        icon: 'mdi-silverware-fork-knife',
        color: '#00b3be',
        description: 'Tradicionalan izgled sa Hero sekcijom, stilizacijom i postavkama prikaza'
      },
      {
        text: 'Modern',
        value: 'modern',
        icon: 'mdi-triangle-outline',
        color: '#3989C9',
        description: 'Moderan i minimalistički template (u pripremi)'
      }
    ],
    fontOptions: [
      { text: 'Default', value: '' },
      { text: 'Roboto', value: 'Roboto, sans-serif' },
      { text: 'Open Sans', value: '"Open Sans", sans-serif' },
      { text: 'Lato', value: 'Lato, sans-serif' },
      { text: 'Montserrat', value: 'Montserrat, sans-serif' },
      { text: 'Poppins', value: 'Poppins, sans-serif' },
      { text: 'Playfair Display', value: '"Playfair Display", serif' },
      { text: 'Merriweather', value: 'Merriweather, serif' }
    ],
    fontSizeOptions: [
      { text: 'Mala', value: 'small' },
      { text: 'Srednja', value: 'medium' },
      { text: 'Velika', value: 'large' },
      { text: 'Vrlo velika', value: 'xlarge' }
    ],
    textAlignOptions: [
      { text: 'Lijevo', value: 'left' },
      { text: 'Centar', value: 'center' },
      { text: 'Desno', value: 'right' }
    ],
    originalSettings: null,
    loading: false,
    saving: false,
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success'
  }),
  watch: {
    menuUrl (newUrl) {
      if (newUrl) {
        // Use double $nextTick to ensure v-if has fully rendered the canvas
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.generateQRCode()
          })
        })
      }
    },
    'settings.qr_menu_enabled' (newVal) {
      // When QR menu is enabled and menuUrl exists, generate QR code
      if (newVal && this.menuUrl) {
        // Use double $nextTick to ensure v-if has fully rendered the canvas
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.generateQRCode()
          })
        })
      }
    }
  },
  computed: {
    menuUrl () {
      if (!this.location) {
        return ''
      }
      const baseUrl = window.location.origin
      return `${baseUrl}/menu/${this.location.id}`
    },
    hasChanges () {
      if (!this.originalSettings) return false
      return JSON.stringify(this.settings) !== JSON.stringify(this.originalSettings)
    },
    currentTemplateComponent () {
      const templateMap = {
        aikasa: 'TemplateAikasa',
        modern: 'TemplateModern'
      }
      return templateMap[this.settings.selected_template] || 'TemplateAikasa'
    }
  },
  async mounted () {
    await this.loadLocationData()
    if (this.menuUrl) {
      // Use double $nextTick to ensure v-if has fully rendered the canvas
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.generateQRCode()
        })
      })
    }
  },
  methods: {
    async generateQRCode (retryCount = 0) {
      if (!this.menuUrl) {
        return
      }

      // If canvas ref not available yet, retry up to 3 times with 100ms delay
      if (!this.$refs.qrcode) {
        if (retryCount < 3) {
          setTimeout(() => {
            this.generateQRCode(retryCount + 1)
          }, 100)
        }
        return
      }

      try {
        await QRCode.toCanvas(this.$refs.qrcode, this.menuUrl, {
          width: 250,
          margin: 2,
          errorCorrectionLevel: 'H',
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
      } catch (error) {
        console.error('Error generating QR code:', error)
        this.showSnackbar('Greška pri generiranju QR koda', 'error')
      }
    },
    async loadLocationData () {
      this.loading = true
      try {
        const pos = state.getPointOfSale()
        if (!pos || !pos.id) {
          this.showSnackbar('Greška: Prodajno mjesto nije učitano', 'error')
          return
        }

        const locationDoc = await df.collection('locations').doc(pos.id).get()
        if (locationDoc.exists) {
          this.location = { id: locationDoc.id, ...locationDoc.data() }

          // Load existing settings
          if (this.location.qr_menu_enabled) {
            this.settings.qr_menu_enabled = this.location.qr_menu_enabled
          }

          if (this.location.qr_menu_settings) {
            const savedSettings = this.location.qr_menu_settings

            // Load selected template
            if (savedSettings.selected_template) {
              this.settings.selected_template = savedSettings.selected_template
            }

            // Load template-specific settings
            if (savedSettings.templates && savedSettings.templates[this.settings.selected_template]) {
              const templateSettings = savedSettings.templates[this.settings.selected_template]
              this.settings = { ...this.settings, ...templateSettings }
            }

            // Load common settings (not template-specific)
            if (savedSettings.enable_ordering !== undefined) {
              this.settings.enable_ordering = savedSettings.enable_ordering
            }
            if (savedSettings.enable_call_waiter !== undefined) {
              this.settings.enable_call_waiter = savedSettings.enable_call_waiter
            }
            if (savedSettings.hide_inactive_items !== undefined) {
              this.settings.hide_inactive_items = savedSettings.hide_inactive_items
            }
            if (savedSettings.hide_empty_categories !== undefined) {
              this.settings.hide_empty_categories = savedSettings.hide_empty_categories
            }
          }

          // Store original settings for change detection
          this.originalSettings = JSON.parse(JSON.stringify(this.settings))
        }
      } catch (error) {
        console.error('Error loading location data:', error)
        this.showSnackbar('Greška pri učitavanju podataka', 'error')
      } finally {
        this.loading = false
      }
    },

    onTemplateChange (templateValue) {
      const templateName = this.templateOptions.find(t => t.value === templateValue)?.text || templateValue

      // Load saved settings for this template if they exist
      if (this.location && this.location.qr_menu_settings && this.location.qr_menu_settings.templates) {
        const templateSettings = this.location.qr_menu_settings.templates[templateValue]

        if (templateSettings) {
          // Preserve qr_menu_enabled, selected_template, and common settings
          const preservedSettings = {
            qr_menu_enabled: this.settings.qr_menu_enabled,
            selected_template: templateValue,
            enable_ordering: this.settings.enable_ordering,
            enable_call_waiter: this.settings.enable_call_waiter,
            hide_inactive_items: this.settings.hide_inactive_items,
            hide_empty_categories: this.settings.hide_empty_categories
          }

          // Apply template settings
          this.settings = { ...this.settings, ...templateSettings, ...preservedSettings }

          this.showSnackbar(`Učitane postavke za predložak: ${templateName}`, 'success')
        } else {
          // No saved settings for this template - keep current settings
          this.showSnackbar(`Odabran predložak: ${templateName} (nove postavke)`, 'info')
        }
      } else {
        this.showSnackbar(`Odabran predložak: ${templateName}`, 'info')
      }
    },

    updateSettings (updatedSettings) {
      this.settings = { ...this.settings, ...updatedSettings }
    },

    onEnableChange () {
      if (!this.settings.qr_menu_enabled) {
        // Reset to defaults when disabling
        this.settings = {
          qr_menu_enabled: false,
          selected_template: 'aikasa',
          show_images: true,
          show_descriptions: true,
          show_allergens: true,
          show_prices: true,
          clickable_items: false,
          enable_ordering: false,
          enable_call_waiter: false,
          hide_inactive_items: true,
          hide_empty_categories: true
        }
      }
    },

    async save () {
      if (!this.location) {
        this.showSnackbar('Greška: Prodajno mjesto nije učitano', 'error')
        return
      }

      this.saving = true
      try {
        const locationRef = df.collection('locations').doc(this.location.id)

        // Get existing templates from database or create empty object
        const existingTemplates = (this.location.qr_menu_settings && this.location.qr_menu_settings.templates) || {}

        // Prepare template-specific settings for current template
        const currentTemplateSettings = {
          hero_image_url: this.settings.hero_image_url || '',
          custom_restaurant_name: this.settings.custom_restaurant_name || '',
          hero_description: this.settings.hero_description || '',
          hero_text_color: this.settings.hero_text_color || '',
          hero_background_color: this.settings.hero_background_color || '',
          hero_transparent_background: this.settings.hero_transparent_background !== undefined
            ? this.settings.hero_transparent_background
            : true,
          hero_font_family: this.settings.hero_font_family || '',
          hero_font_size: this.settings.hero_font_size || 'medium',
          hero_text_align: this.settings.hero_text_align || 'center',
          show_logo: this.settings.show_logo !== undefined ? this.settings.show_logo : true,
          items_primary_color: this.settings.items_primary_color || '#00b3be',
          items_font_family: this.settings.items_font_family || '',
          show_images: this.settings.show_images !== undefined ? this.settings.show_images : true,
          show_descriptions: this.settings.show_descriptions !== undefined ? this.settings.show_descriptions : true,
          show_allergens: this.settings.show_allergens !== undefined ? this.settings.show_allergens : true,
          show_prices: this.settings.show_prices !== undefined ? this.settings.show_prices : true,
          clickable_items: this.settings.clickable_items !== undefined ? this.settings.clickable_items : false
        }

        // Update templates object with current template settings
        const updatedTemplates = {
          ...existingTemplates,
          [this.settings.selected_template]: currentTemplateSettings
        }

        // Prepare complete settings object
        const qrMenuSettings = {
          selected_template: this.settings.selected_template || 'aikasa',
          templates: updatedTemplates,
          // Common settings (not template-specific)
          enable_ordering: this.settings.enable_ordering !== undefined ? this.settings.enable_ordering : false,
          enable_call_waiter: this.settings.enable_call_waiter !== undefined ? this.settings.enable_call_waiter : false,
          hide_inactive_items: this.settings.hide_inactive_items !== undefined ? this.settings.hide_inactive_items : true,
          hide_empty_categories: this.settings.hide_empty_categories !== undefined ? this.settings.hide_empty_categories : true
        }

        await locationRef.update({
          qr_menu_enabled: this.settings.qr_menu_enabled,
          qr_menu_settings: qrMenuSettings
        })

        // Update location cache
        this.location.qr_menu_settings = qrMenuSettings

        // Update original settings after successful save
        this.originalSettings = JSON.parse(JSON.stringify(this.settings))
        this.showSnackbar('Postavke uspješno spremljene', 'success')
      } catch (error) {
        console.error('Error saving QR menu settings:', error)
        this.showSnackbar('Greška pri spremanju postavki', 'error')
      } finally {
        this.saving = false
      }
    },

    downloadQR () {
      try {
        const canvas = this.$refs.qrcode
        if (!canvas) {
          this.showSnackbar('QR kod nije generiran', 'error')
          return
        }

        const url = canvas.toDataURL('image/png')
        const link = document.createElement('a')
        link.download = `qr-menu-${this.location.location_id || this.location.id}.png`
        link.href = url
        link.click()
        this.showSnackbar('QR kod preuzet', 'success')
      } catch (error) {
        console.error('Error downloading QR code:', error)
        this.showSnackbar('Greška pri preuzimanju QR koda', 'error')
      }
    },

    copyUrl () {
      try {
        navigator.clipboard.writeText(this.menuUrl)
        this.showSnackbar('Link kopiran u clipboard', 'success')
      } catch (error) {
        console.error('Error copying URL:', error)
        this.showSnackbar('Greška pri kopiranju linka', 'error')
      }
    },

    printQR () {
      try {
        const canvas = this.$refs.qrcode
        if (!canvas) {
          this.showSnackbar('QR kod nije generiran', 'error')
          return
        }

        let windowContent = '<!DOCTYPE html>'
        windowContent += '<html>'
        windowContent += '<head><title>QR Kod Meni</title>'
        windowContent += '<style>'
        windowContent += 'body { text-align: center; font-family: Arial, sans-serif; padding: 20px; }'
        windowContent += 'h2 { margin-bottom: 20px; }'
        windowContent += 'img { margin: 20px 0; }'
        windowContent += 'p { margin-top: 20px; font-size: 14px; word-break: break-all; }'
        windowContent += '</style>'
        windowContent += '</head>'
        windowContent += '<body>'
        windowContent += `<h2>${this.location.name || 'QR Kod Meni'}</h2>`
        windowContent += `<img src="${canvas.toDataURL()}" alt="QR Code">`
        windowContent += `<p>${this.menuUrl}</p>`
        windowContent += '</body></html>'

        const printWin = window.open('', '', 'width=600,height=600')
        printWin.document.open()
        printWin.document.write(windowContent)
        printWin.document.close()
        printWin.focus()
        printWin.print()
        printWin.close()
      } catch (error) {
        console.error('Error printing QR code:', error)
        this.showSnackbar('Greška pri printanju QR koda', 'error')
      }
    },

    showSnackbar (text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.glass-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(0, 179, 190, 0.2);
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1);
}

.glass-section-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(0, 179, 190, 0.15);
  box-shadow: 0 4px 16px rgba(0, 179, 190, 0.08);
  transition: all 0.3s ease;
}

.glass-section-card:hover {
  background: rgba(255, 255, 255, 0.85);
  border-color: rgba(0, 179, 190, 0.25);
  box-shadow: 0 6px 20px rgba(0, 179, 190, 0.12);
  transform: translateY(-2px);
}

.section-header {
  border-bottom: 1px solid rgba(0, 179, 190, 0.1);
  padding: 12px 16px;
  background: rgba(0, 179, 190, 0.03);
}

.qr-code-wrapper {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 179, 190, 0.15);
  border: 2px solid rgba(0, 179, 190, 0.1);
  transition: all 0.3s ease;
}

.qr-code-wrapper:hover {
  box-shadow: 0 6px 24px rgba(0, 179, 190, 0.2);
  transform: scale(1.02);
}

.v-chip {
  cursor: pointer;
  transition: all 0.2s ease;
}

.v-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.2);
}

/* Input Field Styling - Following STYLING.md filter-select pattern */
.qr-input-field.v-text-field--outlined >>> fieldset,
.qr-input-field.v-select--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.qr-input-field.v-text-field--outlined:hover >>> fieldset,
.qr-input-field.v-select--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.qr-input-field.v-text-field--outlined.v-input--is-focused >>> fieldset,
.qr-input-field.v-select--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.qr-input-field >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 40px !important;
  border-radius: 8px !important;
}

.qr-input-field.v-text-field--outlined >>> .v-input__control,
.qr-input-field.v-select--outlined >>> .v-input__control {
  border-radius: 8px !important;
}

.qr-input-field.v-text-field--outlined >>> .v-text-field__slot,
.qr-input-field.v-select--outlined >>> .v-select__slot {
  border-radius: 8px !important;
}

.qr-input-field >>> .v-select__selection,
.qr-input-field >>> .v-text-field__slot input,
.qr-input-field >>> textarea {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.qr-input-field >>> label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

.qr-input-field.v-input--is-disabled >>> .v-input__slot {
  background: rgba(245, 245, 245, 0.8) !important;
}

.qr-input-field.v-input--is-disabled >>> fieldset {
  border-color: rgba(200, 200, 200, 0.3) !important;
}

/* Dropdown Menu Styling */
.qr-input-field >>> .v-menu__content {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.12) !important;
}

.qr-input-field >>> .v-list-item {
  font-size: 13px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.qr-input-field >>> .v-list-item:hover {
  background: rgba(57, 137, 201, 0.08) !important;
}

.qr-input-field >>> .v-list-item--active {
  background: rgba(0, 179, 190, 0.12) !important;
  color: #3989C9 !important;
}

/* Save Button - Primary Action */
.save-btn {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 50%,
    rgba(97, 84, 164, 0.95) 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 44px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 179, 190, 0.5) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.save-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.save-btn .v-icon {
  color: white !important;
  font-size: 18px !important;
}

/* QR Action Buttons */
.qr-action-btn {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 20px !important;
  height: 36px !important;
  margin: 6px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.qr-action-btn:hover {
  transform: translateY(-2px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.qr-action-btn .v-icon {
  font-size: 18px !important;
}

.qr-action-btn.primary-btn {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 100%) !important;
  color: white !important;
}

.qr-action-btn.primary-btn:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 100%) !important;
  box-shadow: 0 4px 16px rgba(0, 179, 190, 0.4) !important;
}

.qr-action-btn.secondary-btn {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 0.95) 0%,
    rgba(77, 64, 144, 0.9) 100%) !important;
  color: white !important;
}

.qr-action-btn.secondary-btn:hover {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 1) 0%,
    rgba(77, 64, 144, 1) 100%) !important;
  box-shadow: 0 4px 16px rgba(97, 84, 164, 0.4) !important;
}

.qr-action-btn.accent-btn {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%) !important;
  color: white !important;
}

.qr-action-btn.accent-btn:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%) !important;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4) !important;
}
</style>
